import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJirasoftwareComponent } from './simple-icons-jirasoftware.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJirasoftwareComponent ],
    exports:      [ SimpleIconsJirasoftwareComponent ],
    bootstrap:    []
})
export class SimpleIconsJirasoftwareModule {}
